import { isDefined } from "../is/isDefined.js";
function trimObject(obj, isDeeply = false) {
  if (isDeeply) {
    const newObj = {};
    for (const k in obj) {
      if (obj[k] && typeof obj[k] === "object") {
        newObj[k] = trimObject(obj[k], true);
      } else if (isDefined(obj[k])) {
        newObj[k] = obj[k];
      }
    }
    return newObj;
  }
  return Object.entries(obj).filter(([_, v]) => isDefined(v)).reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}
export {
  trimObject
};
